/* ALTIVEST: ekran „Dostawa” między koszykiem a kasą (prototyp, 01.10).
   Koszyk: zamiast „Przejdź do płatności” jest „Wybierz dostawę”.
   Ekran dostawy: Paczkomat (mapa InPost na całą stronę, po wyborze punktu kasa)
   albo Kurier (kasa z adresem). Metody dostawy w kasie Shopify zostają bez zmian.

   P24: obowiązkowa akceptacja Regulaminu sklepu przed przejściem dalej.
*/
(function () {
  'use strict';

  var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var COURIER = 'Inna opcja dostawy';
  var CHOICE_KEY = 'Wybór dostawy InPost';
  var RATES = { paczkomat: '13,99 zł', kurier: '16,99 zł' };

  var ICON = {
    locker: '<svg viewBox="0 0 32 32"><rect x="5" y="5" width="22" height="22" rx="2"/><path d="M5 12h22M5 19h22M16 5v22M10 8.5h2M20 8.5h2M10 15.5h2M20 15.5h2M10 22.5h2M20 22.5h2"/></svg>',
    van: '<svg viewBox="0 0 32 32"><path d="M3 9h16v13H3zM19 13h5l4 4v5h-9z"/><circle cx="9" cy="23.5" r="2.5"/><circle cx="23" cy="23.5" r="2.5"/></svg>'
  };

  function q(s, r) {
    return (r || document).querySelector(s);
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function money(c) {
    return (c / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function buildScreen() {
    var logo = q('header img, .logo img, a[href="/"] img');
    var s = el('section', 'av-ship');

    s.hidden = true;
    s.setAttribute('aria-label', 'Dostawa');

    s.innerHTML =
      '<div class="av-ship__bar">' +
        (logo
          ? '<img src="' + logo.currentSrc + '" alt="ALTIVEST">'
          : '<b>ALTIVEST</b>') +

        '<div class="av-ship__steps">' +
          '<span><i>1</i>Koszyk</span>' +
          '<b><span><i>2</i>Dostawa</span></b>' +
          '<span><i>3</i>Płatność</span>' +
        '</div>' +

        '<button class="av-ship__back" type="button" data-av-ship-back>' +
          'Wróć do koszyka' +
        '</button>' +
      '</div>' +

      '<div class="av-ship__main">' +
        '<div>' +
          '<p class="av-ship__eyebrow">Krok 2 z 3</p>' +

          '<h2>Jak mamy <em>dostarczyć</em> zamówienie?</h2>' +

          '<p class="av-ship__lead">' +
            'Wybierz sposób dostawy. Przy Paczkomacie wskażesz punkt na mapie, a potem przejdziesz do płatności.' +
          '</p>' +

          '<div class="av-ship__opts">' +

            '<button class="av-ship__opt" type="button" data-av-ship="paczkomat">' +
              '<span class="av-ship__ico">' + ICON.locker + '</span>' +
              '<span>' +
                '<span class="av-ship__t">Paczkomat InPost</span>' +
                '<span class="av-ship__s">Odbiór w wybranym Paczkomacie, całą dobę.</span>' +
              '</span>' +
              '<span class="av-ship__p">' + RATES.paczkomat + '</span>' +
            '</button>' +

            '<button class="av-ship__opt" type="button" data-av-ship="kurier">' +
              '<span class="av-ship__ico">' + ICON.van + '</span>' +
              '<span>' +
                '<span class="av-ship__t">Kurier InPost</span>' +
                '<span class="av-ship__s">Dostawa pod wskazany adres.</span>' +
              '</span>' +
              '<span class="av-ship__p">' + RATES.kurier + '</span>' +
            '</button>' +

          '</div>' +

          '<p class="av-ship__note">' +
            'Wybrałeś kuriera? W kasie zaznacz „Kurier InPost”.' +
          '</p>' +

          '<p class="av-ship__err" data-av-ship-err hidden></p>' +
        '</div>' +

        '<aside class="av-ship__sum">' +
          '<h3>Podsumowanie</h3>' +

          '<div class="av-ship__row">' +
            '<span>Produkty</span>' +
            '<span data-av-ship-n></span>' +
          '</div>' +

          '<div class="av-ship__row">' +
            '<span>Dostawa</span>' +
            '<span data-av-ship-d>Do wyboru</span>' +
          '</div>' +

          '<div class="av-ship__tot">' +
            '<span>Razem z produktami</span>' +
            '<b data-av-ship-t></b>' +
          '</div>' +
        '</aside>' +
      '</div>';

    document.body.appendChild(s);
    return s;
  }

  function fillSummary(s) {
    return fetch(R + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        q('[data-av-ship-n]', s).textContent = c.item_count + ' szt.';
        q('[data-av-ship-t]', s).textContent = money(c.total_price);
        return c;
      })
      .catch(function () {});
  }

  function setAttr(value) {
    var a = {};
    a[CHOICE_KEY] = value;

    return fetch(R + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes: a })
    });
  }

  function err(s, t) {
    var e = q('[data-av-ship-err]', s);
    e.textContent = t;
    e.hidden = !t;
  }

  function open(s) {
    s.hidden = false;
    document.documentElement.classList.add('av-ship-open');
    window.scrollTo(0, 0);
    history.pushState({ avShip: 1 }, '', '#dostawa');
    fillSummary(s);
  }

  function close(s) {
    s.hidden = true;
    document.documentElement.classList.remove('av-ship-open');

    if (location.hash === '#dostawa') {
      history.replaceState(null, '', location.pathname);
    }
  }

  function pickLocker(s, btn) {
    err(s, '');

    var api = window.InPostPickup;

    if (!api || typeof api.open !== 'function') {
      err(
        s,
        'Mapa Paczkomatów nie jest teraz dostępna. Wybierz kuriera albo spróbuj ponownie za chwilę.'
      );
      return;
    }

    btn.setAttribute('aria-busy', 'true');

    var tries = 0;

    var t = setInterval(function () {
      var d = q('.inpost-pickup-modal__dialog');

      if ((d && !q('.av-ship__bar', d)) || ++tries > 40) {
        clearInterval(t);

        if (d) {
          var bar = q('.av-ship__bar', s).cloneNode(true);
          bar.classList.add('av-ship__bar--map');
          d.insertBefore(bar, d.firstChild);

          var on = q('.av-ship__steps b i', bar);

          if (on) {
            [
              'background:#0B0C0D',
              'background-color:#0B0C0D',
              'color:#F5F2EB',
              'border-color:#0B0C0D'
            ].forEach(function (r) {
              var kv = r.split(':');
              on.style.setProperty(kv[0], kv[1], 'important');
            });
          }

          var bk = q('[data-av-ship-back]', bar);
          bk.textContent = 'Wróć do wyboru dostawy';

          bk.addEventListener('click', function () {
            var c = q('.inpost-pickup-modal__close');
            if (c) c.click();
          });
        }
      }
    }, 150);

    api
      .open({
        locale: 'pl',
        checkout: true
      })
      .then(function (point) {
        btn.removeAttribute('aria-busy');

        if (point) {
          q('[data-av-ship-d]', s).textContent =
            'Paczkomat ' + (point.name || '');
        }
      })
      .catch(function (e) {
        btn.removeAttribute('aria-busy');

        if (e && (e.code === 'closed' || e.code === 'cancelled')) {
          return;
        }

        err(
          s,
          'Nie udało się otworzyć mapy Paczkomatów. Spróbuj ponownie.'
        );
      });
  }

  function pickCourier(s, btn) {
    err(s, '');
    btn.setAttribute('aria-busy', 'true');

    var api = window.InPostPickup;

    var clear =
      api && typeof api.clear === 'function'
        ? api.clear()
        : Promise.resolve();

    Promise.resolve(clear)
      .catch(function () {})
      .then(function () {
        return setAttr(COURIER);
      })
      .then(function () {
        location.assign(R + 'checkout');
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');

        err(
          s,
          'Nie udało się zapisać wyboru. Spróbuj ponownie.'
        );
      });
  }

  function init() {
    var pays = Array.prototype.slice.call(
      document.querySelectorAll('[data-lc-pay]')
    );

    if (!pays.length) return;

    var s = buildScreen();

    /* =====================================================
       AKCEPTACJA REGULAMINU – wymagana przed kontynuowaniem
       ===================================================== */

    var terms = el(
      'div',
      'av-terms',
      '<label style="display:flex;align-items:flex-start;gap:8px;margin:0 0 12px 0;font-size:13px;line-height:1.4;cursor:pointer;">' +
        '<input ' +
          'type="checkbox" ' +
          'id="av-terms-checkbox" ' +
          'style="margin-top:3px;flex:0 0 auto;"' +
        '>' +
        '<span>' +
          'Akceptuję ' +
          '<a href="/pages/regulamin" target="_blank" rel="noopener" style="text-decoration:underline;">' +
            'Regulamin sklepu' +
          '</a>' +
        '</span>' +
      '</label>'
    );

    pays[0].parentNode.insertBefore(terms, pays[0]);

    /* =====================================================
       PRZYCISK WYBORU DOSTAWY
       ===================================================== */

    var next = el(
      'button',
      'btn btn-brass lc-pay av-ship-next',
      'Wybierz dostawę <span class="stitch"></span>'
    );

    next.type = 'button';

    pays[0].parentNode.insertBefore(next, pays[0]);

    pays.forEach(function (p) {
      p.style.display = 'none';
      p.setAttribute('aria-hidden', 'true');
      p.tabIndex = -1;
    });

    /* Bez akceptacji regulaminu nie można przejść dalej */

    next.addEventListener('click', async function () {
  if (next.disabled) return;

  var checkbox = q('#av-terms-checkbox');

  if (!checkbox || !checkbox.checked) {
    alert('Aby kontynuować, zaakceptuj Regulamin sklepu.');

    if (checkbox) checkbox.focus();

    return;
  }

  var note = document.getElementById('order-note');

  if (!note) {
    alert('Nie udało się odczytać pola uwag. Odśwież stronę i spróbuj ponownie.');
    return;
  }

  var status = document.querySelector('[data-lc-status]');
  var root = (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) || '/';

  next.disabled = true;
  note.readOnly = true;

  if (status) status.textContent = 'Zapisywanie uwag…';

  try {
    var response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        note: note.value
      })
    });

    if (!response.ok) {
      throw new Error('Nie udało się zapisać uwag.');
    }

    var updatedCart = await response.json();

    if ((updatedCart.note || '') !== note.value) {
      throw new Error('Nie potwierdzono zapisu uwag.');
    }

    if (status) status.textContent = '';

    open(s);
  } catch (error) {
    if (status) {
      status.textContent =
        'Nie udało się zapisać uwag. Kliknij „Wybierz dostawę”, aby spróbować ponownie.';
    }
  } finally {
    next.disabled = false;
    note.readOnly = false;
  }
});


    s.addEventListener('click', function (e) {
      var b = e.target.closest('[data-av-ship]');

      if (b) {
        (
          b.dataset.avShip === 'paczkomat'
            ? pickLocker
            : pickCourier
        )(s, b);

        return;
      }

      if (e.target.closest('[data-av-ship-back]')) {
        history.back();
      }
    });

    window.addEventListener('popstate', function () {
      if (location.hash !== '#dostawa') {
        close(s);
      }
    });

    if (location.hash === '#dostawa') {
      open(s);
    }

    /* Pusty koszyk: brak dostawy */

    document.addEventListener('lc:cart-updated', function (ev) {
      next.hidden = !!(
        ev.detail &&
        ev.detail.item_count === 0
      );

      terms.hidden = !!(
        ev.detail &&
        ev.detail.item_count === 0
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();